import React from "react";
import { trackEvent } from "@leafly-com/web-utils";

import Placeholder, { Rect } from "components/Placeholder";
import Sort from "components/Sort";

/* eslint-disable sort-keys-fix/sort-keys-fix -- exception: order matters */
const sortOptions: { [key: string]: string } = {
  Recommended: "recommended:asc",
  "A-Z": "strain_name:asc",
  "Z-A": "strain_name:desc",
  "Highest Rated": "rating:desc",
  "Most Reviews": "review_count:desc",
  Newest: "created:desc",
};
/* eslint-enable sort-keys-fix/sort-keys-fix -- exception: order matters */

const StrainListCountSort: React.FC<{
  totalCount?: number;
  loading?: boolean;
}> = ({ totalCount, loading }) => {
  const handleClick = (newSortOption: string) => {
    trackEvent("Strains Sort", "Click", newSortOption);
  };

  return (
    <div className="flex justify-between items-center mb-sm">
      <div className="text-xs font-bold">
        {!loading ? (
          `${totalCount} strains`
        ) : (
          <Placeholder height="20" width="70">
            <Rect height="100%" width="100%" />
          </Placeholder>
        )}
      </div>

      <Sort sortOptions={sortOptions} onClick={handleClick} />
    </div>
  );
};

export default StrainListCountSort;
